module.exports = __webpack_public_path__ + "static/media/mockups-2.6ae2813c.jpg";